export enum BlockEmptyStateType {
  topicRecommendations = "topicRecommendations",
  alerts = "alerts",
  topicInsights = "topicInsights",
  sentiments = "sentiments",
  recommendations = "recommendations",
}
